import Resource from '@/api/core/resource'
import appConfig from '@/config/appConfig'

class Comprobante extends Resource {
  constructor () {
    super('tesoreria/comprobantes')
  }
  cambiarEstado (comprobanteId, codigoEstado) {
    return this.request.get(
      this.uri
        .concat('/')
        .concat(comprobanteId)
        .concat('/cambiar-estado/')
        .concat(codigoEstado)
    )
  }
  obtenerComprobantesCentroParaAsociacion (comprobanteId) {
    return this.request.get(
      this.uri
        .concat('/')
        .concat(comprobanteId)
        .concat('/comprobantes-centro-asociacion')
    )
  }
  prefacturar (comprobanteId, itemsAsociados, itemsNoAsociadosAbiertos) {
    return this.request.put(
      this.uri
        .concat('/')
        .concat(comprobanteId)
        .concat('/prefacturar'),
      {
        itemsAsociados: itemsAsociados,
        itemsNoAsociadosAbiertos: itemsNoAsociadosAbiertos
      }
    )
  }
  procesarFacturaPrestacionPami (comprobanteId) {
    return this.request.get(
      this.uri
        .concat('/')
        .concat(comprobanteId)
        .concat('/procesar-factura-prestacion-pami')
    )
  }
  generarComprobanteVta (comprobanteId) {
    return this.request.get(
      this.uri
        .concat('/')
        .concat(comprobanteId)
        .concat('/generar-comprobante-vta')
    )
  }
  descargarComprobanteVta (comprobanteId) {
    window.open(
      appConfig.urlServer.concat(
        this.uri
          .concat('/')
          .concat(comprobanteId)
          .concat('/descargar-comprobante-vta')
      )
    )
  }
  obtenerDetalleComprobante (filtros) {
    return this.request.post(this.uri.concat('/detalle-comprobante'), filtros)
  }
  obtenerConceptosComprobante (filtros) {
    return this.request.post(this.uri.concat('/conceptos-comprobante'), filtros)
  }
  cambiarPLN (comprobanteId, datos) {
    return this.request.put(
      this.uri
        .concat('/')
        .concat(comprobanteId)
        .concat('/cambiar-pln'),
      datos
    )
  }
  buscarComprobanteParaCompensar (datos) {
    return this.request.post(
      this.uri
        .concat('/buscar-comprobante-compensar'),
      datos
    )
  }
  generarArchivosTxt (comprobanteId) {
    window.open(
      appConfig.urlServer.concat(
        this.uri
          .concat('/')
          .concat(comprobanteId)
          .concat('/generar-archivos-txt')
      )
    )
  }

  obtenerUrlImportarExcelPami (comprobanteId) {
    return appConfig.urlApi.concat(
      this.uri
        .concat('/')
        .concat(comprobanteId)
        .concat('/importar-excel-pami')
    )
  }

  impactarExcelPami (comprobanteId, archivo) {
    return this.request.get(
      this.uri
        .concat('/')
        .concat(comprobanteId)
        .concat('/impactar-excel-pami?archivo=')
        .concat(archivo)
    )
  }

  obtenerDetalleDevolucionPami (filtros) {
    return this.request.post(this.uri.concat('/detalle-devolucion-pami'), filtros)
  }

  obtenerOrdenesPago (comprobanteId, filtros) {
    return this.request.post(this.uri.concat('/').concat(comprobanteId).concat('/ordenes-pago'), filtros)
  }

  exportarPacientesLaboratorios (comprobanteId) {
    window.open(
      appConfig.urlServer.concat(
        this.uri
          .concat('/')
          .concat(comprobanteId)
          .concat('/exportar-pacientes-laboratorios')
      )
    )
  }
}

export default new Comprobante()
